import axios from 'axios';
import { BASE_URL } from '../common/urls';
import { getToken } from '../msalConfig';

export const axiosInstance = axios.create({
    baseURL: BASE_URL
});

axiosInstance.interceptors.request.use(async function (config) {
    const token = await getToken();
    config.headers.Authorization =  token ? `Bearer ${token}` : '';
    return config;
});
